import React from "react";
import { LawFirmFuzzyMatchDialogBound } from "../../../features/bonds/shared/components/LawFirmFuzzyMatchDialog";

export default function RegisterFuzzyMatchDialog({ p }) {
  const {
    fuzzyMatchDialogOpen,
    setFuzzyMatchDialogOpen,
    fuzzyMatchResult,
    setFuzzyMatchResult,
    handleUseExistingLawFirm,
    handleCreateNewLawFirmAnyway,
  } = p;

  return (
    <LawFirmFuzzyMatchDialogBound
      open={fuzzyMatchDialogOpen}
      setOpen={setFuzzyMatchDialogOpen}
      fuzzyMatchResult={fuzzyMatchResult}
      setFuzzyMatchResult={setFuzzyMatchResult}
      onUseExisting={handleUseExistingLawFirm}
      onCreateAnyway={handleCreateNewLawFirmAnyway}
      showCancel
      useExistingLabel="Use existing firm"
    />
  );
}
